// Fouten in de browser gaan naar het foutenregister van Jerome (POST /api/errors), zodat ze in
// Ontwikkelen verschijnen en Jerome ze zelf kan oplossen. Per sessie één melding per fouttekst.

const seen = new Set<string>();

export interface ClientErrorReport {
  message: string;
  stack?: string;
  context?: Record<string, unknown>;
}

export function describeError(e: unknown): ClientErrorReport {
  if (e instanceof Error) return { message: e.message.slice(0, 2000), ...(e.stack ? { stack: e.stack.slice(0, 20000) } : {}) };
  if (typeof e === 'string') return { message: e.slice(0, 2000) };
  try {
    return { message: JSON.stringify(e).slice(0, 2000) };
  } catch {
    return { message: String(e).slice(0, 2000) };
  }
}

export function shouldReport(report: ClientErrorReport): boolean {
  if (!report.message || /ResizeObserver loop|Failed to fetch|Load failed|NetworkError|AbortError|niet ingelogd/i.test(report.message)) return false;
  if (seen.has(report.message)) return false;
  seen.add(report.message);
  return true;
}

export function reportClientError(e: unknown, context: Record<string, unknown> = {}, send: (body: ClientErrorReport) => Promise<unknown> = defaultSend): Promise<void> {
  const r = describeError(e);
  if (!shouldReport(r)) return Promise.resolve();
  const body: ClientErrorReport = { ...r, context: { ...context, source: 'client', url: typeof location === 'undefined' ? '' : location.pathname, userAgent: typeof navigator === 'undefined' ? '' : navigator.userAgent.slice(0, 200) } };
  return send(body).then(() => undefined, () => undefined);
}

function defaultSend(body: ClientErrorReport): Promise<unknown> {
  return fetch('/api/errors', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin', keepalive: true });
}

export function installErrorReporting(target: Window = window): void {
  target.addEventListener('error', (ev) => void reportClientError(ev.error ?? ev.message, { where: 'window.error', file: ev.filename, line: ev.lineno }));
  target.addEventListener('unhandledrejection', (ev) => void reportClientError(ev.reason, { where: 'unhandledrejection' }));
}
